module.exports = __webpack_public_path__ + "media/אור.b12627bc.mp3";